import { FC } from 'react'

import { PlanItem } from '../PlanItem'
import { useSubscriptionPlan } from '../../useSubscriptionPlan'
import { Container, Title } from '../../styles'

import { List, TitleWrapper } from './styles'

export const PlansList: FC = () => {
  const { plans } = useSubscriptionPlan()

  return (
    <Container>
      <TitleWrapper>
        <Title>Choose your plan</Title>
      </TitleWrapper>

      <List>
        {plans.map((plan, index) => (
          <PlanItem isBig={index === 1} plan={plan} key={plan.name} />
        ))}
      </List>
    </Container>
  )
}
